import {Component} from '@angular/core';
import {SelectInput} from "../../shared/dropdown/shared/select-input.class";
import { Router } from '@angular/router';

@Component({
  selector: 'avs-app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.css']
})
export class AppFooterComponent {
  public isFooterMenuOpen: boolean = false;
  public footerMenuSelectInput: SelectInput[] = [
    {name: 'Impressum', routerLink:'/impressum'},
    {name: 'Datenschutz', routerLink:'/privacy'},
    {name: 'AGB'}
  ]; //  {name: 'Cookie-Einstellungen'}, {name: 'FAQ', routerLink:'/faq'}
  /*     {name: 'Datenschutz'},
  {name: 'Cookie-Einstellungen'},
*/
  public isMouseOverIcon = false;

  public onFooterMenuButtonClicked(): void {
    this.isFooterMenuOpen = !this.isFooterMenuOpen;
  }

  public onMenuListItemClicked(): void {
    this.isFooterMenuOpen = false;
  }
}
